import { normalizeRoleSlug } from "../../../public/utils/roleAccess";
import {
  PROPERTY_ASSETS_CONTROL_SUBMODULE_SLUG,
  PROPERTY_ASSETS_SUBMODULE_SLUG,
} from "./propertyAssetPermissionSlugs";

function permRow(permMap, slug) {
  const row = permMap?.[slug];
  return row && typeof row === "object" ? row : {};
}

function registerStylePerms(row) {
  const canView = Boolean(row.view);
  const canCreate = Boolean(row.create);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  return {
    canView: canView || canCreate,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: false,
    canDeleteMasters: false,
    canExport: canView || canCreate,
    isAdmin: false,
    limitedEdit: true,
  };
}

function controlStylePerms(permMap) {
  const row = permRow(permMap, PROPERTY_ASSETS_CONTROL_SUBMODULE_SLUG);
  const registerRow = permRow(permMap, PROPERTY_ASSETS_SUBMODULE_SLUG);
  const canView = Boolean(row.view);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  const canCreate = Boolean(row.create) || Boolean(registerRow.create);
  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
    canManageMasters: canView && canEdit,
    canDeleteMasters: canDelete,
    canExport: canView,
    isAdmin: canView,
    limitedEdit: false,
  };
}

export function buildPropertyAssetPermissionsForScreen(
  permMap = {},
  _roleSlug = "",
  screenSlug = "",
) {
  const slug = normalizeRoleSlug(screenSlug);

  if (slug === PROPERTY_ASSETS_SUBMODULE_SLUG) {
    return registerStylePerms(permRow(permMap, slug));
  }

  if (slug === PROPERTY_ASSETS_CONTROL_SUBMODULE_SLUG) {
    return controlStylePerms(permMap);
  }

  return buildPropertyAssetPermissions(permMap);
}

export function buildPropertyAssetPermissions(permMap = {}) {
  const control = controlStylePerms(permMap);
  const register = registerStylePerms(permRow(permMap, PROPERTY_ASSETS_SUBMODULE_SLUG));
  return {
    canView: control.canView || register.canView,
    canCreate: control.canCreate || register.canCreate,
    canEdit: control.canEdit || register.canEdit,
    canDelete: control.canDelete,
    canManageMasters: control.canManageMasters,
    canDeleteMasters: control.canDeleteMasters,
    canExport: control.canExport || register.canExport,
    isAdmin: control.isAdmin,
    limitedEdit: register.canEdit && !control.canEdit,
  };
}
